import { Component, Input, OnChanges } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { CellRow, ColumnText, ComponentData, EquityRiskInsightsTransform, FiRiskInsightsTransform, TabUtil, TotalActiveRiskInsightsTransform, TotalRiskInsightsTransform } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'risk-characteristic-insights',
	templateUrl: './characteristic-insights.component.html',
	styleUrls: ['./characteristic-insights.component.scss']
})
export class CharacteristicInsightsComponent implements OnChanges {
	@Input() public data: ComponentData;
	public transformedData: CellRow[];
	public title: string;
	public selectedPortfolioIndex: number = 0;

	constructor(public contentSvc: ContentService) { }

	public ngOnChanges(): void {
		if (this.isInsightVisible()) {
			const titleColumn = get(this.data, 'tabs[0].config.title.label') as ColumnText;
			this.title = titleColumn ? this.contentSvc.get(titleColumn.key, titleColumn.defaultText) : `BlackRock's view on risk for`;

			switch (this.data.id) {
				case 'total.risk.decomposition.insights':
					this.transformedData = new TotalRiskInsightsTransform(this.contentSvc).transform(this.data);
					break;
				case 'active.risk.decomposition.insights':
					this.transformedData = new TotalActiveRiskInsightsTransform(this.contentSvc).transform(this.data);
					break;
				case 'risk.equity.insights':
					this.transformedData = new EquityRiskInsightsTransform(this.contentSvc).transform(this.data);
					break;
				case 'risk.fixed.income.insights':
					this.transformedData = new FiRiskInsightsTransform(this.contentSvc).transform(this.data);
					break;
			}
		} else {
			this.transformedData = null;
		}
	}

	private isInsightVisible(): boolean {
		const isComponentDataSuccessful = this.data && this.data.success;
		return isComponentDataSuccessful && get(this.data, 'tabs', []).every(tab => TabUtil.isTabValid(tab));
	}

	public changeIndex(event: any): void {
		this.selectedPortfolioIndex = event.target.value || 0;
	}

	public isFieldAvailable(fieldName: string): boolean {
		const fieldValue = get(this.transformedData, `[${this.selectedPortfolioIndex}].field[${fieldName}].formattedValue`);
		return !!fieldValue && fieldValue.replace(/\s/g, '').length > 0;
	}
}
